<template>
        <div class="row product-select-field-wrapper">
            <div class="col col-lg-10">
                <select
                    class="form-control product-select-field"
                    v-model="selected"
                    v-on:input="fillOutFromDropdown($event.target.value)"
                    v-on:blur="fillOutFromDropdown($event.target.value)"
                >
                    <option value="" disabled>
                        {{field.placeholder ? field.placeholder : "Please select value"}}
                    </option>
                    <option
                        v-for="option in field.options"
                        :key="option.id"
                        :value="option.value"
                    >
                        {{option.label}} - {{option.price | toCurrency}}
                    </option>
                </select>
            </div>
            <div class="col col-lg-2">
                <Quantity
                    :min="min"
                    :defaultQuantity="defaultQuantity"
                    :disableQuantity="field.product.disableQuantity"
                    v-on:filled-out="fillOutFromQuantity($event)"
                >
                </Quantity>
            </div>
        </div>
</template>

<script>
  import FieldLabel from '../FieldLabel';
  import Quantity from './Quantity';

  export default {
    props: {
      field: {},
      value: '',
    },
    data() {
      return {
        min: 1,
        quantity: 1,
        selected: '',
        defaultQuantity: 1,
        filledOutData: {}
      };
    },
    created() {
        //this.selected = this.value;
    },
    methods: {
        fillOutFromDropdown(value) {
            this.filledOutData = {};
            this.filledOutData[value] = this.quantity;
            this.$emit('filled-out', this.filledOutData);
        },
        fillOutFromQuantity(value) {
            this.quantity = value;
            this.filledOutData = {};
            this.filledOutData[this.selected] = value;
            this.$emit('filled-out', this.filledOutData);
        }
    },
    computed: {
        paymentsListClass() {
            return {
                'payments-list-field': true,
                'with-quantity': !this.field.product.disableQuantity
            };
        }
    },
    components: {
      FieldLabel,
      Quantity
    },
  };
</script>

<style>
.product-select-field {
    height: 3rem;
}
.product-select-field-wrapper .payments-quantity {
    margin-left: 0;
}
</style>
